import { Settlement } from "redux/constants/Settlement";

const initState = {
    data: [],
    loading: false,
  };
  
  const settlement = (state = initState, action) => {
    switch (action.type) {
      case Settlement.LOADING_SETTLEMENT_LIST:
        return {
          ...state,
          loading: action.payload,
        };
      case Settlement.GET_SETTLEMENT_LIST:
        return {
          ...state,
          data: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default settlement;